<template>
  <section class="core">
    <div class="container">
      <a-typography-title :level="1">
        核心功能
      </a-typography-title>
      <a-typography-paragraph>
        多维度助力提升业务运维效率
      </a-typography-paragraph>
      <a-row :gutter="[50,20]">
        <template v-for="(item,index) in expand.list">
          <a-col v-if="$Store.Public().isGridMatch('>=',$Enum.GridEnum.MD)||index<4||expand.active"
                 :xs="24" :md="12" :xl="8">
            <div class="item" :class="[`i_${index+1}`,`i_${index%2?'right':'left'}`]">
              <a-typography-title :level="5">
                {{ item.title }}
              </a-typography-title>
              <a-typography-paragraph>
                {{ item.text }}
              </a-typography-paragraph>
            </div>
          </a-col>
        </template>
        <a-col v-if="$Store.Public().isGridMatch('<',$Enum.GridEnum.MD)"
               :span="24">
          <a-button type="link" class="button_more"
                    @click="expand.active=!expand.active">
            <template #icon>
              <DownCircleOutlined v-if="!expand.active" />
              <UpCircleOutlined v-else />
            </template>
          </a-button>
        </a-col>
      </a-row>
      <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
        <a-button type="link" class="button_n_3"
                  @click="$RQ.GoGSS()">
          立即体验
        </a-button>
        <a-button type="link" class="button_n_3"
                  @click="$Store.Page().openModal('modalFormCollection', 'demo')">
          预约咨询
        </a-button>
      </a-space>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DownCircleOutlined, UpCircleOutlined } from '@ant-design/icons-vue';

import { DataInterface } from '@interface/public';

export default {
  name: 'product_core',
  components: {
    DownCircleOutlined,
    UpCircleOutlined
  },
  data(): DataInterface {
    return {
      expand: {
        active: false,
        list: [
          {
            title: '决策支持',
            text: '高密度展现有效决策信息，全面实现业务态势感知，助您迅速合理决策'
          },
          {
            title: '多云管理',
            text: '统一管理多云、混合云算力资源，1分钟内可获取高达1000台机器'
          },
          {
            title: '弹性扩缩容',
            text: '1分钟1000台服务器极速扩容，从容应对高峰流量'
          },
          {
            title: '快速部署',
            text: '支持基于流水线自定义应用发布流程，减少重复操作，显著提升发布效率'
          },
          {
            title: '成本效率',
            text: '从费用、算力、利用率维度洞察资源现状，成本管理精细化、自动化'
          },
          {
            title: '快速压测',
            text: '分钟级快速压测，发现最适合业务现状的服务器规格，资源效能最大化'
          },
          {
            title: '整租零售',
            text: '高配裸金属服务器切割，获得任意规格算力，CPU低至0.001核，内存低至0.001G'
          },
          {
            title: '指标监控',
            text: '支持物理、业务、决策指标，应用、服务集群等多层次的指标监控'
          },
          {
            title: '生态对接',
            text: '支持对接众多第三方平台，携手共建行业生态，实现持续技术演进和自动化CI/CD'
          }
        ]
      }
    };
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@imagePublic: '@{src_image}page/public/';
@image: '@{src_image}page/productSchedulX/';

.core {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  .bg('@{imagePublic}bg_1.jpg');
  background-size: cover;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
    text-align: center;
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

div.ant-typography {
  margin: @margin_mo 0 0;
  .font(center, @text+@line, @color_13, @text);
}

.ant-row {
  margin: @margin_mo 0 0;
}

.item {
  @h: 120px;
  @wh: 60px;
  overflow: hidden;
  position: relative;
  width: 100%;
  max-width: 380px;
  height: @h;
  margin: 0 auto;
  background: @color_white;
  border-radius: 10px;
  .shadow(2px 2px 10px fade(#0E2456, 8));
  
  &:hover {
    &::before {
      opacity: 0;
    }
    
    h5.ant-typography {
      color: @color_white;
      .transform(translate(0, -30px));
    }
    
    div.ant-typography {
      .transform(translateY(-100%));
      opacity: 1;
    }
  }
  
  .loop(@i) when (@i<=9) {
    &.i_@{i} {
      &::before {
        background-position: -(-1+@i)*@wh 0;
      }
    }
    
    .loop(@i+1);
  }
  .loop(1);
  
  &::before {
    content: '';
    display: block;
    .position(absolute, 50%, auto, auto, 50%);
    z-index: 0;
    width: @wh;
    height: @wh;
    .transform(translate(calc(~'-50% - 80px'), calc(~'-50% + 2px')));
    .bg('@{image}core_icon.png', @wh*9, @wh);
    .transition(opacity @time);
  }
  
  h5.ant-typography {
    @style: color @time, transform @time;
    .position();
    z-index: 2;
    width: 150px;
    height: @text_big+4px;
    margin: auto;
    .font(center, @text_big+4px, @color_12, @text_big+4px, true);
    .transform(translate(40px, 0));
    .transition(@style);
  }
  
  div.ant-typography {
    @style: opacity @time, transform @time;
    .position(top, 100%);
    z-index: 1;
    height: @h;
    padding: 55px 30px 0;
    margin: 0;
    .bg('@{image}core_item_bg.jpg');
    background-size: cover;
    .font(justify, @text+@line, @color_white, @text);
    opacity: 0;
    .transition(@style);
  }
}

.button_more {
  display: block;
  width: 100%;
  height: auto;
  padding: 5px 0;
  border: none;
  
  > * {
    .font(center, 30px, @color_13, 30px, true);
  }
}

.ant-space {
  margin: @margin 0 0;
}

@media screen and (max-width: -1px+@grid_xl) {
  .item {
    &.i_left {
      float: right;
    }
    
    &.i_right {
      float: left;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .core {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo+10px, @color_12, @title_mo, true);
  }
  
  div.ant-typography {
    .font(center, @text_big_mo, @color_12, @text_big_mo);
  }
  
  .ant-row {
    margin: @margin_mo 0 0;
  }
  
  .item {
    float: none !important;
    
    &::before {
      .transform(translate(calc(~'-50% - 60px'), calc(~'-50% + 2px')) scale(0.7));
    }
    
    h5.ant-typography {
      height: @text_big_mo;
      .font(center, @text_big_mo, @color_6, @text_big_mo, true) !important;
      .transform(translate(0, -30px)) !important;
    }
    
    div.ant-typography {
      padding: 50px 20px 0;
      .font(justify, @text_mo+@line, @color_13, @text_mo) !important;
      background: @color_white;
      opacity: 1;
      .transform(translateY(-100%)) !important;
    }
  }
}
</style>